import {
  BreakpointIdentifier,
  BreakpointsConfiguration,
} from './BreakpointsProvider'

/**
 * Get a breakpoints pixel sizes. This will return a array because devices have multiple breakpoints.
 * @param breakpointOrDevice 'mobile', 'tablet, 'desktop', or a breakpoint defined in type Breakpoints'
 * @returns An array with pixels sorted from small to large
 */
export const breakpointToPixels = (
  breakpointsConfiguration: BreakpointsConfiguration,
  breakpointOrDevice: string,
): number[] => {
  const { aliases, breakpoints } = breakpointsConfiguration

  const devices: { [key: string]: string[] } = {
    mobile: aliases.mobile,
    tablet: aliases.tablet,
    desktop: aliases.desktop,
  }

  // If it is a device, get the breakpoints for the device.
  const breakpoint = devices[breakpointOrDevice] || [breakpointOrDevice]

  // Get the pixels per breakpoint. If it is not a breakpoint it should
  // already be a number, so return that instead.
  const pixels = breakpoint.map((b) =>
    breakpoints[b as BreakpointIdentifier] === undefined
      ? parseFloat(b)
      : breakpoints[b as BreakpointIdentifier],
  )

  // Sort from small to large
  return pixels.sort((a, b) => a - b)
}
